<template>
<ValidationProvider tag="div" class="w-100" :vid="vid" :name="name" v-slot="{ errors }">
<AccordionCollapse :title="name" :collapsed="collapsed">
    <CRow>
        <CCol col="12" sm="6" class="border-secondary p-0">
            <CInput
                class="m-0 py-3 bg-gray-100 p-20-15"
                v-model="search"
                @input="searchItem"
            />
            <div class="p-15 position-relative">
                <CElementCover v-if="showLoading" :opacity="0.8" style="z-index:1"/>
                <CListGroup>
                    <CListGroupItem
                        class="border-0 cursor-pointer"
                        v-for="(item, index) in unselected"
                        :key="index"
                        @click="event => selectItem(event, item)"
                    >
                        <FaIcon icon="folder" />
                        {{ item.name }}
                    </CListGroupItem>
                </CListGroup>
            </div>
        </CCol>
        <CCol col="12" sm="6" class="border-secondary p-0">
            <div class="m-0 py-3 bg-gray-100 p-20-15">
                <span class="selected-area-header">
                    {{ $t('selected_area') }}
                </span>
            </div>
            <div class="p-15 position-relative">
                <CListGroup>
                    <CListGroupItem
                        class="border-0 cursor-pointer"
                        v-for="(item, index) in selected"
                        :key="index"
                        @click="event => unselectItem(event, item)"
                    >
                        <FaIcon icon="folder" />
                        {{ item.name }}
                    </CListGroupItem>
                </CListGroup>
            </div>
        </CCol>
    </CRow>
</AccordionCollapse>
<div>
    <span class="invalid-feedback d-block">{{ errors[0] }}</span>
</div>
</ValidationProvider>
</template>

<script>
import { DefaultInputProps } from './defaultProps'
import AccordionCollapse from '@/components/AccordionCollapse'

export default {
    name: 'CColumnSelect',

    components: {
        AccordionCollapse,
    },

    props: {
        ...DefaultInputProps,
        filterData: {
            required: true,
            type: Function
        },
        data: {
            required: true,
        },
        value: {
            default() {
                return {}
            }
        },
        collapsed: {
            default: false,
            type: Boolean
        }
    },

    data() {
        return {
            showLoading: false,
            search: '',
            ss: this.value
        }
    },

    computed: {
        unselected() {
            const selectedKeys = Object.keys(this.value)

            return Object.keys(this.data).map(id => {
                if(!selectedKeys.includes(id)) {
                    return this.data[id]
                }
            }).filter(Boolean)
        },
        selected: {
            get() {
                return this.ss
            },
            set(newVal) {
                this.ss = newVal
            }
        }
    },

    methods: {
        searchItem() {
            this.showLoading = true
            clearTimeout(this.typingTimout)

            const hideLoading = () => {
                this.showLoading = false
            }
            this.typingTimout = setTimeout(() => {
                new Promise((resolve) => {
                    this.filterData(this.search)
                    resolve()
                }).then(hideLoading)
            }, 1000)
        },

        selectItem(event, item) {
            this.selected = Object.assign({}, this.selected, {
                [item.id]: item
            })

            this.$delete(this.unselected, item.id)

            this.$emit('input', this.selected)
        },
        unselectItem(event, item) {
            this.$set(this.unselected, item.id, item)

            this.$delete(this.selected, item.id)

            this.$emit('input', this.selected)
        }
    }
}
</script>


<style lang="scss" scoped>
.selected-area-header {
    padding: 0.375rem 0.75rem;
    height:calc(1.5em + 0.75rem + 2px);
    display: block;
}
.p-15 {
    padding: 15px!important;
}
.p-20-15 {
    padding: 20px 15px!important;
}
</style>